// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file user.proto (package org.callistovault.v2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import { file_options } from "./options_pb";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file user.proto.
 */
export const file_user: GenFile = /*@__PURE__*/
  fileDesc("Cgp1c2VyLnByb3RvEhRvcmcuY2FsbGlzdG92YXVsdC52MiKLAQoWUmVzcG9uZFRvU3VydmV5UmVxdWVzdBIKCgJwaxgBIAEoDBIqCglyZXNwb25zZXMYAiABKAsyFy5nb29nbGUucHJvdG9idWYuU3RydWN0EgwKBGtpbmQYAyABKAkSFAoMbGlua2VkX2VudHJ5GAQgASgJEhUKDWxpbmtlZF9jYW1wdXMYBSABKAkiKwoXUmVzcG9uZFRvU3VydmV5UmVzcG9uc2USEAoIc3VydmV5SUQYASABKAkiKAoSVmVyaWZ5RW1haWxSZXF1ZXN0EhIKCmdpdmVuRW1haWwYASABKAkiPgoTVmVyaWZ5RW1haWxSZXNwb25zZRIUCgxpc0ZvcmVpZ25FZHUYASABKAgSEQoJZW5jcnlwdGVkGAIgASgMIkgKEFZlcmlmeUVtYWlsSW5uZXISEgoKZ2l2ZW5FbWFpbBgBIAEoCRIRCglwYXJ0bmVySWQYAiABKAkSDQoFbmV3SWQYAyABKAkypQIKC1VzZXJTZXJ2aWNlEj4KBkxvZ291dBIWLmdvb2dsZS5wcm90b2J1Zi5FbXB0eRoWLmdvb2dsZS5wcm90b2J1Zi5FbXB0eSIEkLUYARJwCg9SZXNwb25kVG9TdXJ2ZXkSLC5vcmcuY2FsbGlzdG92YXVsdC52Mi5SZXNwb25kVG9TdXJ2ZXlSZXF1ZXN0Gi0ub3JnLmNhbGxpc3RvdmF1bHQudjIuUmVzcG9uZFRvU3VydmV5UmVzcG9uc2UiABJkCgtWZXJpZnlFbWFpbBIoLm9yZy5jYWxsaXN0b3ZhdWx0LnYyLlZlcmlmeUVtYWlsUmVxdWVzdBopLm9yZy5jYWxsaXN0b3ZhdWx0LnYyLlZlcmlmeUVtYWlsUmVzcG9uc2UiAEIZWhdjYWxsaXN0b3ZhdWx0Lm9yZy9wcm90b2IGcHJvdG8z", [file_google_protobuf_empty, file_google_protobuf_struct, file_options]);

/**
 * @generated from message org.callistovault.v2.RespondToSurveyRequest
 */
export type RespondToSurveyRequest = Message<"org.callistovault.v2.RespondToSurveyRequest"> & {
  /**
   * @generated from field: bytes pk = 1;
   */
  pk: Uint8Array;

  /**
   * @generated from field: google.protobuf.Struct responses = 2;
   */
  responses?: JsonObject;

  /**
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * @generated from field: string linked_entry = 4;
   */
  linkedEntry: string;

  /**
   * @generated from field: string linked_campus = 5;
   */
  linkedCampus: string;
};

/**
 * Describes the message org.callistovault.v2.RespondToSurveyRequest.
 * Use `create(RespondToSurveyRequestSchema)` to create a new message.
 */
export const RespondToSurveyRequestSchema: GenMessage<RespondToSurveyRequest> = /*@__PURE__*/
  messageDesc(file_user, 0);

/**
 * @generated from message org.callistovault.v2.RespondToSurveyResponse
 */
export type RespondToSurveyResponse = Message<"org.callistovault.v2.RespondToSurveyResponse"> & {
  /**
   * @generated from field: string surveyID = 1;
   */
  surveyID: string;
};

/**
 * Describes the message org.callistovault.v2.RespondToSurveyResponse.
 * Use `create(RespondToSurveyResponseSchema)` to create a new message.
 */
export const RespondToSurveyResponseSchema: GenMessage<RespondToSurveyResponse> = /*@__PURE__*/
  messageDesc(file_user, 1);

/**
 * @generated from message org.callistovault.v2.VerifyEmailRequest
 */
export type VerifyEmailRequest = Message<"org.callistovault.v2.VerifyEmailRequest"> & {
  /**
   * @generated from field: string givenEmail = 1;
   */
  givenEmail: string;
};

/**
 * Describes the message org.callistovault.v2.VerifyEmailRequest.
 * Use `create(VerifyEmailRequestSchema)` to create a new message.
 */
export const VerifyEmailRequestSchema: GenMessage<VerifyEmailRequest> = /*@__PURE__*/
  messageDesc(file_user, 2);

/**
 * @generated from message org.callistovault.v2.VerifyEmailResponse
 */
export type VerifyEmailResponse = Message<"org.callistovault.v2.VerifyEmailResponse"> & {
  /**
   * @generated from field: bool isForeignEdu = 1;
   */
  isForeignEdu: boolean;

  /**
   * @generated from field: bytes encrypted = 2;
   */
  encrypted: Uint8Array;
};

/**
 * Describes the message org.callistovault.v2.VerifyEmailResponse.
 * Use `create(VerifyEmailResponseSchema)` to create a new message.
 */
export const VerifyEmailResponseSchema: GenMessage<VerifyEmailResponse> = /*@__PURE__*/
  messageDesc(file_user, 3);

/**
 * VerifyEmailInner is the contents of the encrypted blob returned from VerifyEmail.
 *
 * @generated from message org.callistovault.v2.VerifyEmailInner
 */
export type VerifyEmailInner = Message<"org.callistovault.v2.VerifyEmailInner"> & {
  /**
   * @generated from field: string givenEmail = 1;
   */
  givenEmail: string;

  /**
   * @generated from field: string partnerId = 2;
   */
  partnerId: string;

  /**
   * @generated from field: string newId = 3;
   */
  newId: string;
};

/**
 * Describes the message org.callistovault.v2.VerifyEmailInner.
 * Use `create(VerifyEmailInnerSchema)` to create a new message.
 */
export const VerifyEmailInnerSchema: GenMessage<VerifyEmailInner> = /*@__PURE__*/
  messageDesc(file_user, 4);

/**
 * UserService implements APIs for fetching/mutating user-related data in the system.
 *
 * @generated from service org.callistovault.v2.UserService
 */
export const UserService: GenService<{
  /**
   * Logout destroys the user's current session and all associated tokens.
   *
   * @generated from rpc org.callistovault.v2.UserService.Logout
   */
  logout: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof EmptySchema;
  },
  /**
   * RespondToSurvey adds a user's response to a survey.
   *
   * @generated from rpc org.callistovault.v2.UserService.RespondToSurvey
   */
  respondToSurvey: {
    methodKind: "unary";
    input: typeof RespondToSurveyRequestSchema;
    output: typeof RespondToSurveyResponseSchema;
  },
  /**
   * VerifyEmail will send an email to the user with a PIN that they can sign up with.
   *
   * @generated from rpc org.callistovault.v2.UserService.VerifyEmail
   */
  verifyEmail: {
    methodKind: "unary";
    input: typeof VerifyEmailRequestSchema;
    output: typeof VerifyEmailResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_user, 0);

